import React, { useState, forwardRef } from "react";
import { Box, Modal } from "@mui/material";
import Copy from "../Assests/AlertModal/copy.svg";
import Storesetting from "../Assests/AlertModal/storesetting.svg";
import Slide from "@mui/material/Slide";
import DeleteModalIcon from "./DeleteModalIcon";
import CloseIcon from "../Assests/Dashboard/cross.svg";
import CircularProgress from "@mui/material/CircularProgress";

const ConfirmModal = ({
  headerText,
  otherMSG,
  open,
  titleSuggestion,
  onClose,
  onConfirm,
  isHideImage,
  isHideCancelButton,
  isLoading,
  isDanger,
  useDefaultIcon,
}) => {
  const overlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1300, // Ensure it appears on top of other content
  };
  const myStyles = {
    // width: "90%", // Use % instead of fixed vh
    maxWidth: "500px", // Limit max width on large screens
    position: "absolute",
    top: "50%",
    left: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transform: "translate(-50%, -50%)",
    fontFamily: "'CircularSTDMedium', sans-serif",
    padding: "16px", // Optional: Add some inner spacing
    boxSizing: "border-box",
  };

  const cancelImage = {
    position: "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
  };
  const showDeleteIcon = isDanger && !useDefaultIcon;

  const imageDisplay = (headerText) => {
    switch (headerText) {
      case "The existing Variants of the selected Store 2 Must be same as selected Store 1 Variants. Do you want to proceed?":
        return Copy;
      case "The existing setting of the selected Store 2 will be erased and your setting will be copied from Store 1 to the selected Store 2. Do you want to proceed?":
        return Storesetting;
      case "Confirm Close Refund":
        return Copy;
      case "Are you sure you want to make these changes?":
        return Copy;
      default:
        return Copy;
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        className="delete-modal-outer-div"
        closeAfterTransition
      >
        <Slide direction="down" in={open} mountOnEnter unmountOnExit>
          <Box style={overlayStyles}>
            <Box
              className="delete-Box-modal"
              sx={{ width: { xs: "95%", sm: "60%" } }}
              style={myStyles}
            >
              <div className="delete-modal">
                <div className="delete-modal-content">
                  {!isHideImage && showDeleteIcon ? <DeleteModalIcon /> : null}
                  {!isHideImage && !showDeleteIcon && imageDisplay(headerText) ? (
                    <img
                      src={imageDisplay(headerText)}
                      alt={`Copy-icon`}
                      loading="lazy"
                    />
                  ) : null}
                  <span>{headerText ? <>{headerText}</> : ""}</span>
                </div>
                <div className="delete-modal-button">
                  {isHideCancelButton ? (
                    <img
                      src={CloseIcon}
                      alt=""
                      className="delete-image"
                      style={cancelImage}
                      onClick={onClose}
                    />
                  ) : (
                    <button onClick={onClose}>Cancel</button>
                  )}

                  <button
                    onClick={onConfirm}
                    style={{
                      background:
                        isDanger && !useDefaultIcon ? "#FF4040" : "var(--qv-brand, #0a64f9)",
                      color: "#fff",
                      margin: isHideCancelButton ? "auto" : "0 auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                    className={isDanger && !useDefaultIcon ? undefined : "qv-order-primary-btn"}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <Box className="loader-box">
                        <CircularProgress />
                      </Box>
                    ) : (
                      ""
                    )}
                    {titleSuggestion ? titleSuggestion : "OK"}
                  </button>
                </div>
              </div>
            </Box>
          </Box>
        </Slide>
      </Modal>
    </>
  );
};

export default ConfirmModal;
